import { render, staticRenderFns } from "./brandActivity.vue?vue&type=template&id=7ed2a981&"
import script from "./brandActivity.vue?vue&type=script&lang=js&"
export * from "./brandActivity.vue?vue&type=script&lang=js&"
import style0 from "./brandActivity.vue?vue&type=style&index=0&id=7ed2a981&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports